import React, { useState } from 'react';
import { useCliente } from '../../context/ClienteContext.jsx';
import { useConfig } from '../../context/ConfigContext.js';
import './ClienteAuthForm.css';

// Aplica máscara según el patrón (X = dígito, resto = literal)
function applyMask(digits, mask) {
    let result = '';
    let di = 0;
    for (let mi = 0; mi < mask.length && di < digits.length; mi++) {
        if (mask[mi] === 'X') {
            result += digits[di++];
        } else {
            result += mask[mi];
            // Si el siguiente char del input era el separador, avanzar
            if (digits[di] === mask[mi]) di++;
        }
    }
    return result;
}

// Cuenta cuántos X tiene la máscara (máx dígitos permitidos)
function maxDigits(mask) {
    return mask.split('').filter(c => c === 'X').length;
}

export default function ClienteAuthForm({ onSuccess }) {
    const { login, register } = useCliente();
    const { ClienteAuth } = useConfig();
    const prefix = ClienteAuth?.phonePrefix ?? '';
    const mask   = ClienteAuth?.phoneMask   ?? 'XXXXXXXXXX';
    const maxLen = maxDigits(mask);

    const [modo, setModo] = useState('login');
    const [telefono, setTelefono] = useState(prefix);
    const [contrasena, setContrasena] = useState('');
    const [nombre, setNombre] = useState('');
    const [error, setError] = useState('');
    const [cargando, setCargando] = useState(false);

    const handleTelefonoChange = (e) => {
        const raw = e.target.value;

        // No permitir borrar el prefijo
        if (!raw.startsWith(prefix)) {
            setTelefono(prefix);
            return;
        }

        // Extraer solo dígitos después del prefijo y aplicar máscara
        const afterPrefix = raw.slice(prefix.length).replace(/\D/g, '').slice(0, maxLen);
        setTelefono(prefix + applyMask(afterPrefix, mask));
    };

    const handleCambiarModo = (nuevoModo) => {
        setModo(nuevoModo);
        setError('');
        setTelefono(prefix); // resetear al cambiar de tab
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setCargando(true);
        try {
            const data = modo === 'login'
                ? await login(telefono, contrasena)
                : await register(telefono, contrasena, nombre);

            if (data.error) {
                setError(data.error);
            } else {
                if (onSuccess) onSuccess(data.cliente);
            }
        } catch {
            setError('Error de conexión. Intenta de nuevo.');
        } finally {
            setCargando(false);
        }
    };

    return (
        <div className="cliente-auth-form">
            <div className="cliente-auth-tabs">
                <button
                    className={`cliente-auth-tab ${modo === 'login' ? 'active' : ''}`}
                    onClick={() => handleCambiarModo('login')}
                    type="button"
                >
                    Iniciar sesión
                </button>
                <button
                    className={`cliente-auth-tab ${modo === 'registro' ? 'active' : ''}`}
                    onClick={() => handleCambiarModo('registro')}
                    type="button"
                >
                    Registrarse
                </button>
            </div>

            <form onSubmit={handleSubmit} className="cliente-auth-fields">
                {modo === 'registro' && (
                    <input
                        type="text"
                        placeholder="Nombre completo"
                        value={nombre}
                        onChange={e => setNombre(e.target.value)}
                        maxLength={100}
                        required
                    />
                )}
                <input
                    type="tel"
                    inputMode="numeric"
                    placeholder={prefix + mask.replace(/X/g, '0')}
                    value={telefono}
                    onChange={handleTelefonoChange}
                    required
                    maxLength={prefix.length + mask.length}
                    autoComplete="tel"
                />
                <input
                    type="password"
                    placeholder="Contraseña"
                    value={contrasena}
                    onChange={e => setContrasena(e.target.value)}
                    required
                    minLength={6}
                    autoComplete={modo === 'login' ? 'current-password' : 'new-password'}
                />
                {error && <p className="cliente-auth-error">{error}</p>}
                <button type="submit" className="cliente-auth-btn" disabled={cargando}>
                    {cargando ? 'Procesando...' : modo === 'login' ? 'Entrar' : 'Crear cuenta'}
                </button>
            </form>
        </div>
    );
}
